import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VBtn,
    {
      class: { "appointment-button_club-gradient": _vm.isClubEnabled },
      attrs: {
        "data-qa": "appointment_submit_button",
        color: "primary",
        elevation: "0",
        disabled:
          !_setup.familyProfilesStore.isFamilyRequestDone ||
          (_setup.lpuDataStore.isTelemedMedical &&
            _setup.familyProfilesStore.isUnderagePatient),
        block: "",
      },
      on: {
        click: function ($event) {
          return _setup.emit("click:appointment")
        },
      },
    },
    [
      _vm._t("default", function () {
        return [
          _setup.appointmentDataStore.appointmentRegistrationTypes.isExpress
            ? [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("Заказать звонок", _setup.options)) +
                    "\n    "
                ),
              ]
            : _setup.appointmentDataStore.isAnyTelemed
            ? [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("Продолжить", _setup.options)) +
                    "\n    "
                ),
              ]
            : _vm.isClubEnabled
            ? [
                _vm._v(
                  "\n      Перейти к оплате " +
                    _vm._s(_setup.onlinePriceClub) +
                    "\n    "
                ),
              ]
            : [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("Записаться", _setup.options)) +
                    "\n    "
                ),
              ],
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }